import { createSvg } from '@r1-frontend/ui-kit/atoms/svg/createSvg';

const InfoCircleFlip = (
    {
        strokeWidth = 1.5,
    },
): JSX.Element => {
    return <>
        <g id={'contour'}>
            <path
                d='M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2Z'
                strokeWidth={strokeWidth}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </g>
        <g id={'guts'}>
            <path
                d='M12 16V11'
                strokeWidth={strokeWidth}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M12.0055 8H11.9965'
                strokeWidth={strokeWidth}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </g>
    </>;
};

export default createSvg(
    InfoCircleFlip,
    'info-circle-flip',
);
